import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Button } from "reactstrap";
import { BUTTON_ACTIONS, getButtonAction } from "@dhn/shared/button-actions";

/**
 * Botón genérico con el color, ícono y texto que la regla del sistema define
 * para su acción. `label` cambia solo el texto; `isLoading` muestra el spinner.
 *
 * <ActionButton action="add" onClick={openModal} />
 * <ActionButton action="delete" size="sm" onClick={() => onRemove(row)} />
 */
export default function ActionButton({ action, label, isLoading, className, children, ...props }) {
  const config = getButtonAction(action);

  return (
    <Button
      type="button"
      {...props}
      color={config.color}
      className={classnames(config.className, className)}
    >
      <i className={`fa ${isLoading ? "fa-spinner fa-spin" : config.icon}`} aria-hidden="true"></i>
      {children || ` ${label || config.label}`}
    </Button>
  );
}

ActionButton.propTypes = {
  action: PropTypes.oneOf(Object.keys(BUTTON_ACTIONS)).isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
};

ActionButton.defaultProps = {
  isLoading: false,
};
